<template>
  <!-- eslint-disable -->
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead01">
                <div class="inner4">
                    <h1><img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/title.png" srcset="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/title@2x.png 2x" alt='ニコンイメージングジャパン 東京カメラ部10選U-22と次の未来を語る ～新世代のNikon Creators～' /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2022年9月16日（金）～9月19日（月・祝）、東京・渋谷ヒカリエにて「東京カメラ部2022写真展」が開催されました。開催期間中のイベントステージでは、人気フォトグラファー、写真業界関係者、歴代東京カメラ部10選などをお招きして、さまざまなテーマでトークショーが行われました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            9月19日（月・祝）に行われたニコンイメージングジャパンのトークショーでは、東京カメラ部10選U-22の池田拓海氏、酒井雄世氏、東京カメラ部10選の石田卓士氏、半田菜摘氏にご登壇いただき、「東京カメラ部10選U-22と次の未来を語る～新世代のNikon Creators～」というテーマでお話しいただきました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/01.jpg" alt="ニコンイメージングジャパン 01" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            東京カメラ部運営 塚崎（司会）「みなさん、こんにちは。東京カメラ部の塚崎と申します。本日は『東京カメラ部10選U-22と次の未来を語る～新世代のNikon Creators～』と題したトークショーを開催させていただきたいと思います。スペシャルゲストを4名お呼びしてお送りいたします。それでは早速皆さまにご挨拶をいただきたいと思います」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/02.jpg" alt="ニコンイメージングジャパン 02" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            池田「東京カメラ部10選U-22 2021の池田拓海です。熊本県に住んでいて、モトクロスや風景写真を撮影しています」<br>
                            <br>
                            塚崎「池田さんがニコンのカメラを最初に手にしたのはいつごろでしょうか？」<br>
                            <br>
                            池田「D5300というエントリー機をいちばん最初に使い始めました。高校三年生のときに購入して、飛行機を撮影していました。そこからモトクロスや風景写真を撮ろうと思ったときに、Z 6を使い始めました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/03.jpg" alt="ニコンイメージングジャパン 03" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いて酒井さんお願いいたします」<br>
                            <br>
                            酒井「酒井雄世と申します。今年から大阪で医師1年目として働きながら、旅行先で写真を撮っています。写真を始めたのはいまから5年前、大学二年生のときです。もともと旅行が好きで、そのお供にカメラを買いました。2年前（2020年）に東京カメラ部10選U-22に選んでいただいて、その特典として得たモニター経験をきっかけに、去年ニコン機材を購入しました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/04.jpg" alt="ニコンイメージングジャパン 04" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「東京カメラ部10選U-22というのを簡単にご説明したいと思います。ニコンイメージングジャパンと東京カメラ部がタイアップしたフォトコンテストで、“次世代を担う若者が撮影する作品”をテーマとしています。2020年と2021年で計2回開催しており、22歳以下、もしくは20代の学生に参加を限定しています。そこで選ばれた方を『東京カメラ部10選U-22』として認定しております。現在2022年のコンテストを開催中です。ニコンが開催しているので、機材はニコンに限定しているかというとそうではありません。機材の縛りはなく入選されています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/05.jpg" alt="ニコンイメージングジャパン 05" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続きまして、石田さんお願いします」<br>
                            <br>
                            石田「みなさんこんにちは。U-52の石田です。新潟から来ました。普段は総合病院に勤務しながら、休日や夜間に棚田や花火の写真を撮影しています。本日はよろしくお願いいたします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/06.jpg" alt="ニコンイメージングジャパン 06" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続きまして、半田さんお願いします」<br>
                            <br>
                            半田「U-22＋αの半田です。地元北海道で野生動物を撮影しています。もともと魚釣りが趣味で釣りばかりしていたのですが、その中の友人がカメラをやっていて、それがきっかけで2013年から写真を撮り始めました。本日はよろしくお願いします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/07.jpg" alt="ニコンイメージングジャパン 07" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「それでは早速、U-22のおふたりがどんな写真を普段撮っているのかをお伺いしようと思います。撮影ジャンルや、そのジャンルを撮り始めたきっかけも教えてください」<br>
                            <br>
                            池田「こちらはモトクロスの写真で、U-22に選んでいただいた写真です。モトクロスとは、整備された道ではなくオフロードという土や泥だらけの道を走っていくバイクの競技です。こちらは迫力のある写真を象徴するような一枚になります。かなり連写するので一日数千枚単位で撮影するのですが、こんなに迫力のある写真が撮れるのはその中で1枚撮れるかどうかですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/08.jpg" alt="ニコンイメージングジャパン 08" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            池田「島根県隠岐島の写真です。この辺りは馬が放牧されていて、ご飯を食べている様子です。隠岐島には壮大な景色があって、迫力のある風景写真が撮れるいい場所です」<br>
                            <br>
                            塚崎「迫力あるモトクロスの写真と風景写真。幅があるように思いますが、普段はどちらがメインですか？」<br>
                            <br>
                            池田「普段は風景写真を撮っていて、たまにモトクロスの写真を撮りに行きます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/09.jpg" alt="ニコンイメージングジャパン 09" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            池田「阿蘇の木島岳山頂から撮影した雲海と天の川の写真です。写っているのは知り合いなのですが、人を画面の前に入れることで、スケール感が出て壮大になっていると思います」<br>
                            <br>
                            半田「街明かりが浮き上がっていてそれでいて星がすごくきれい。池田さんもおっしゃっていましたが、人を入れることで宇宙に立っている感じというか、空の広さがわかって格好いいですね」<br>
                            <br>
                            石田「四隅の星が線ではなく、ちゃんと点で解像しているのがすごいと思います」<br>
                            <br>
                            池田「Z 9とNIKKOR Z 20mm f/1.8 Sという素晴らしいレンズで撮りました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/10.jpg" alt="ニコンイメージングジャパン 10" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            池田「長崎県の白木峰高原という、九州では有名なスポットです。夜中からカメラマンが場所取りをするので、激戦区です。三脚を置いてずっと待っていました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/11.jpg" alt="ニコンイメージングジャパン 11" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            池田「九州の火山帯で咲くミヤマキリシマというきれいなツツジの花です。奥に阿蘇の火山があり、朝焼けと共に撮影しました」<br>
                            <br>
                            石田「手前から奥までしっかり解像していて、色もきれいで素晴らしい」<br>
                            <br>
                            池田「手前から奥までしっかり解像するには、大体被写界深度合成が頭をよぎると思うのですが、これはF18で撮影していて、一枚撮りで決めたいという思いがありました。Nikon Zシリーズには解析補正というものがあります。絞ると解像度が落ちるものですが、それを補正して相当程度防いでくれるんです。撮影に集中できました。朝焼けの写真は1秒1秒表情が変わっていくので、その一瞬を捉えられるよう一枚撮りに専念しました」<br>
                            <br>
                            酒井「奥から手前まで完全にピントが合っていて、手前の方の浮き上がり方が象徴的できれいだなと思いました」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/12.jpg" alt="ニコンイメージングジャパン 12" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            池田「阿蘇の草原です。牛が放牧されているんですね。道の先に太陽がある構図がいいなと思って撮影しました」<br>
                            <br>
                            半田「モニターの大きな画面で見るとさらに緑のグラデーションの立体感、奥行き感が素晴らしいなと思いました」<br>
                            <br>
                            石田「まっすぐ太陽が入っているのに、フレアが出ていないですね」<br>
                            <br>
                            池田「NIKKOR Z 24-70mm f/4 Sで撮影しています。逆光耐性が高いレンズなので、太陽を入れた構図でも活躍してくれます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/13.jpg" alt="ニコンイメージングジャパン 13" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「こういうふうに撮影しているんですね」<br>
                            <br>
                            池田「中には入れないので、柵の後ろから撮影しています」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/14.jpg" alt="ニコンイメージングジャパン 14" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いて酒井さんお願いします」<br>
                            <br>
                            酒井「こちらは去年の12月、種子島でロケットの打ち上げがあった際の写真です。当時国家試験の一ヶ月前だったのですが、一生に一度は見てみたいなと思った景色だったので、急遽行って撮った写真です」<br>
                            <br>
                            半田「人生がかかった国試の一ヶ月前って、信じられないです！国試も一生に一度ですけどね（笑）」<br>
                            <br>
                            酒井「それくらい撮りたい被写体でした（笑）。風景写真は通ってなんぼとよく言われますが、自分としては写真は旅とセットなので、被写体とは一期一会なんです。なのでその分インターネットやSNSなどで下調べを入念にするようにしています。この写真に関しては、この時の星とロケットの軌跡をいかに両立させるかというのと、あとは何mmで撮るかを考えました。遠すぎてもダメだし、近すぎてもフレームアウトしてしまうので、バランス感を考えて決めました。ロケットが弧を描くように打ち上げられるのですが、どこでシャッターボタンを離そうか、というのは考えました。長すぎるとフレームアウトしてしまうし、短すぎると写真としてバランスが悪くなってしまう。あとは画面の下が水面なので、リフレクションすればいいのですが、しなかったらどうやってこのスペースを見せようかというのを考えて撮影しました」<br>
                            <br>
                            塚崎「入念に準備をしているんですね」<br>
                            <br>
                            酒井「どうしても初めての被写体が多いので、目で見ることはできないけれども、実際目で見たらどういう風になるのかを想像しています」<br>
                            <br>
                            塚崎「実際に機材を揃えたんですね」<br>
                            <br>
                            酒井「このときの撮影までは他社のカメラを使っていましたが、夜中の撮影だし、撮ったら大きく見せたいということもあるので、2日前にZ 7IIとNIKKOR Z 14-30mm f/4 S を急いで購入しました。一昨年のモニターで使わせていただいて、この撮影にはZ 7IIが必要だと思いました」<br>
                            <br>
                            塚崎「U-22に入選すると、ニコンのギャラリーで合同展を開催していただけます。その上で、ニコンの機材をモニターとして試せるんです」<br>
                            <br>
                            塚崎「買った甲斐はありましたか？」<br>
                            <br>
                            酒井「十分にありました。この機材のおかげで撮れたと思います」<br>
                            <br>
                            石田「チャンスを逃したくないですよね。そのときの選択肢として、機材に余裕があればあるほど設定の幅が広がるので、機材は大切だと思いますね」<br>
                            <br>
                            塚崎「なければ撮れないということではないですが、機材がその性能でカバーしてくれることで余裕が生まれてミスの確率が下がるということですね」<br>
                            <br>
                            石田「構図もそうですが、全く白飛びしていないのがすごいなと思います。絞り気味でアンダーに撮ると思うのですが、それでも暗部がこうして立ち上がる。黒つぶれしにくいという、この機種の良いところを活かした一枚だと思いました」<br>
                            <br>
                            池田「僕もこの日は別の場所でロケットを撮っていたのですが、長秒露光でノイズは乗るし、ロケットは白飛びするしで大変でした。センサーの性能は大事だと思いました」<br>
                            <br>
                            塚崎「機材の性能が高いと表現の幅が広がるということですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/15.jpg" alt="ニコンイメージングジャパン 15" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            酒井「あしかがフラワーパークの藤のライトアップの写真です。本当は別の場所に行く予定だったのですが、夜が大雨の予報だったので、それだったら木目の地面に雨が反射してくれるのではないかと思い、無人になるのをひたすらに待って撮影しました。あとで見返してみると棒や木目の部分が斜めになっていると後悔することが多いので、その辺りを意識して撮影しました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/16.jpg" alt="ニコンイメージングジャパン 16" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            酒井「秋田にある渓流の写真です。運よく光芒が入り、川面に反射してくれました」<br>
                            <br>
                            池田「光芒が上から入るのはなかなかないですよね。大体は斜めから入ると思うので。羨ましいですね」<br>
                            <br>
                            酒井「時間は朝の9時くらい。日の出が6時だったのでひたすら待ちました。ミラーレスのように軽量なカメラですと持ち運びも楽ですし、レンズが前に飛び出していないので渓流撮影の際にNDフィルターも使いやすい。気軽に持ち運べる良いレンズだなと思いますね。撮影の敷居が格段に下がったと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/17.jpg" alt="ニコンイメージングジャパン 17" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            酒井「花火の撮影も好きで、いろいろなところを旅行がてら巡回しています。ミュージック花火というもので、感動的な写真になりました。また来年も撮影したいと思います。このように全国各地を撮ろうとしています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
				
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/18.jpg" alt="ニコンイメージングジャパン 18" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            酒井「北海道の神威岬というところです。旅行の際に撮影しました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/19.jpg" alt="ニコンイメージングジャパン 19" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            酒井「郡上八幡城の雪景色です。条件的になかなか雲海に当たらないときもあるのですが、運よく出てくれました。少し暗い状況だったのですが現像でしっかり持ち上がりました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/20.jpg" alt="ニコンイメージングジャパン 20" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
							塚崎「そして撮影の様子です。これ撮影風景なんですか？カメラ構えてないですよね？（笑）」<br>
                            <br>
                            酒井「彼女に撮ってもらったんです（笑）」<br>
                            <br>
                            池田「モデルさんみたいで羨ましいですね（笑）」<br>
                            <br>
                            半田「おしゃれすぎますね（笑）」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/21.jpg" alt="ニコンイメージングジャパン 21" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「それでは東京カメラ部10選のお二方の写真以外でのお仕事と、普段どんな写真を撮っているかを教えてください。撮影ジャンルや、撮りはじめたきっかけも伺いたいと思います。まずは石田さんお願いします」<br>
                            <br>
                            石田「普段は人口20万人弱くらいの都市の病院に勤務しています。夜と朝を中心に写真を撮りに行っています。こちらは初めて早起きをして朝焼けを撮りに行ったときの写真です。病院から車で20分くらいの場所で、初めて撮りに行ったときにこの風景だったので、すっかりハマってしまいました。このあとずっと通っていますが、ここまでの景色は撮れていません。何年かに一度のタイミングだったのかもしれません」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/22.jpg" alt="ニコンイメージングジャパン 22" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
							石田「新潟は米所なので棚田はたくさんあります。他の棚田にも通うようになり、今年の春に撮影した写真です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/23.jpg" alt="ニコンイメージングジャパン 23" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            石田「秋の雲海と、光芒が差している写真です。新潟にいると、30～40分の車移動でこういう景色が撮れるポイントがたくさんあります。仕事をしながら続けられている一つの要素が地理的なこともあると思います」<br>
                            <br>
                            塚崎「東京カメラ部10選の方は実は人口比で言うとびっくりするくらい首都圏の方が少ないんです。撮影地が近いところ、つまり首都圏以外に多くの方がお住まいなんです。その上、今は発信媒体が、SNSなどなので、発信することに地域のハードルもない。その結果、首都圏以外の地域が有利になっている。そこを生かして、どんどん地域の魅力を発信する方が増えているなと感じます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/24.jpg" alt="ニコンイメージングジャパン 24" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            石田「春に秋田県の大曲で撮った花火です。枝垂れ桜と一緒に撮りました。花火は休日に開催されるので、比較的スケジュールの調整はつけやすいですね」<br>
                            <br>
                            塚崎「半田さんはいかがでしょう？スケジュールの調整がつきやすいところだとこういうのが撮りやすいとか」<br>
                            <br>
                            半田「わたしは季節で考えていて、紅葉の山が撮りたいなと思ったら、紅葉に当たりそうなところで有給を申請しています。モモンガの繁殖が3月なので、撮りたいなと思えばそこで休みを取ったりとか。シフト制なので、生態系に合わせて休みを取っています」<br>
                            <br>
                            塚崎「医療関係者のおふたりは激務だと思いますが、このように上手く調整していくと写真を撮り続けられるということですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->


                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/25.jpg" alt="ニコンイメージングジャパン 25" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            石田「NIKKOR Z 100-400mm f/4.5-5.6 VR Sが出たときに、ニコンさんからご依頼をいただき撮りました。テーマに風景・動物と書いてあったので、Z 9で動物瞳AFを使用しました。しっかりピントが合って解像しています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->


                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/26.jpg" alt="ニコンイメージングジャパン 26" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            石田「これも同じくZ 9とNIKKOR Z 100-400mm f/4.5-5.6 VR Sの組み合わせです。320mmくらいの焦点距離でノートリミングで、猿が飛ぶ瞬間を撮りました。猿が岩に登ったので、飛ぶだろうなというタイミングを狙って、瞳AFを使用したので簡単に撮れてしまいました。驚いたのがISO2000で撮っていて、RAWではなくJPEGなんです。明るさだけ調整したのですが、カメラ内のノイズ処理が優秀なので、場合によってはRAWからPCで現像した写真よりも撮って出しのJPEG写真の方がノイズが少ないことまであります。自分のPC現像がカメラの処理に勝てなかったんです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/27.jpg" alt="ニコンイメージングジャパン 27" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そして。この写真がすごいと伺っています」<br>
                            <br>
                            石田「志賀高原の天の川の写真です。Z 9とNIKKOR Z 20mm f/1.8 Sの組み合わせで撮影していますが、実は撮って出しなんです。全くPC現像していません」<br>
                            <br>
                            塚崎「星を撮る方ならわかりますよね。天の川は普通はRAWデータからPCで現像するものなんです。Z 9がそれだけ素晴らしいということですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/28.jpg" alt="ニコンイメージングジャパン 28" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いて半田さんお願いします」<br>
                            <br>
                            半田「わたしは看護師としてフルタイムで働いています。内科や外科、認知症の患者さんが多い病棟です。夜勤もあるので、夜勤前や夜勤明けに撮影しています。今年の夏はエゾオコジョが撮りたくて山に入っていました。この日も日没ギリギリまで動物はいなかったのですが、薄暗くなってきたら、なんとエゾオコジョが6匹出たんですね。オコジョは珍しいんですよ。一匹でも興奮するのですが、この時は6匹も出ました。そして2匹並んでいるところを撮りました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/29.jpg" alt="ニコンイメージングジャパン 29" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「こちらもそのときに撮ったものなのですが、オコジョがエゾヤチネズミを咥えている場面です。肉食なのでネズミを食べるんですね。捕食して巣まで運んでいるのですが、動きがすごく速いんです。岩場を縫うように走るのですが、それを3Dトラッキングで追尾してくれたので、わたしはファインダーで追うだけですね。秒間20コマの連写も強力なので、いちばん足が浮いている一枚を選びました」<br>
                            <br>
                            塚崎「打率（撮影した中で成功と判断できる写真の枚数が増える確率）が上がりますね」<br>
                            <br>
                            半田「いままでだと苦労して撮影した一枚になると思うのですが、Z 9だと撮れる。お世辞じゃなくて打率が上がったと感じます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/30.jpg" alt="ニコンイメージングジャパン 30" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「ミサゴがフナを取ったところを、後ろからトンビが奪いにきて狙っているシーンです。一回しかチャンスがないですし、何年に一度巡り合えるかどうかというところだと思うのですが、向こうから手前まで飛んでくるのを全てのカットを逃すことなくオートフォーカスで抑えてくれるので、わたしはあとでいい一枚を選ぶだけですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/31.jpg" alt="ニコンイメージングジャパン 31" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「かわいい動物はわたしも好きですし、色鮮やかで映える写真も好きなのですが、撮るなかでいちばん大切にしているのは動物と対峙している時間です。このときは雨予報だったので誰もいなかったのですが、湖畔の上をキツネが歩いてくるのがわかっていたんですね。虫やリスなど餌になるようなものを探してながら歩いていて、すると雨が降ってきて、キツネが徐々に濡れていくんです。同じようにわたしもずぶ濡れになっていくんですよ。そうして同じ空間を共有したと実感できたと思ったし、そういう対峙する瞬間を醍醐味にしているので、撮れてよかったなと思いました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/32.jpg" alt="ニコンイメージングジャパン 32" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「オジロワシがサギを捕食して、そのあとカラスやワシに横取りされないように持って逃げているところです。こういった野生動物の厳しい一面もわたしにとって大切なものです。可愛い、きれい、美しいだけじゃなくて、生々しかったり厳しいと思うところも含めて自然すべてをリスペクトして撮っていくということを大事にしています。このときは雨が降っていたのですが、傘を差したり、ビニールを巻いたりするタイミングはないんです。雨に強いニコンの機材は躊躇しないで取り出せるので、わたしにとって大きな好きな要素です」<br>
                            <br>
                            池田「モトクロス撮るとき砂が舞うのですが、僕もカバーはしないです。やはり操作が煩わしくなってしまう部分もあるので、ガンガン使っちゃいます」<br>
                            <br>
                            酒井「花火を撮る際に雨が降ってきたのですが、ニコンを信頼して僕もあまり気にしなかったです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/33.jpg" alt="ニコンイメージングジャパン 33" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「ヨタカの写真です。夏の時期に卵を産みにくるのですが、歩いていたらたまたま地面から飛び出してきました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/34.jpg" alt="ニコンイメージングジャパン 34" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「地面を見てみるとヨタカの卵が。ヨタカはこのように、地面にぽろっと卵を産むんです。最初は知らないまま近付いてしまったので飛び立ってしまったのですが、大切に撮りたいと思ったので、ストレスを与えないようにその日はなにもせずに帰りました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/35.jpg" alt="ニコンイメージングジャパン 35" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「場所だけ覚えておいて、翌日ゆっくり近づいてまず一枚撮りました。ヨタカの下に卵がある状態なのですが、びっくりさせないようにするにはどうしたらいいかなと考えて、次のように撮影しました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/36.jpg" alt="ニコンイメージングジャパン 36" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「奥に三脚とカメラがあるのですが、一ヶ月間三脚は置きっぱなしにしました。『SnapBridge』という純正アプリを使ってスマホとカメラを同期すれば、スマホからシャッターを切れます。わたしはカメラから離れて、ヨタカを直接見ることなくシャッターを切っていました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/37.jpg" alt="ニコンイメージングジャパン 37" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そして撮れたのがこの写真ですね」<br>
                            <br>
                            半田「親子の2ショットを撮りたいとずっと思っていて、やっと撮れた写真です。これを撮るためにずっと通っていたので、本当に親子が並んでいるのを見て震えましたね。なかなかこういう写真は見たことないんじゃないでしょうか。頑張ってよかったなと思います。実は手前の葉っぱに蟻が一匹いるのもポイントです。動物は緊張していると毛が逆立ったり、なんらかのサインが出るんですね。調べてみると、ヨタカはびっくりすると羽を広げるらしいのですが、そういったことは一回もなかったです」<br>
                            <br>
                            塚崎「驚かさないという点では、音の問題も大きいですよね」<br>
                            <br>
                            半田「そうですね。パシャッというシャッター音は普段聞かない、自然界にはない音ですよね。Z 9はシャッター音がなく、わたしが動かない限り音が出ないので、動物写真家にとっては革命的ですよね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/38.jpg" alt="ニコンイメージングジャパン 38" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「ここからは『写真と仕事』をテーマにクロストークを行っていただきます。まずは仕事が忙しくても機材を持って撮影に行く理由や、本業と写真の両方に熱意を持ち続けられる理由を教えていただきたいと思います。まず池田さんからお願いします」<br>
                            <br>
                            池田「自分は風景写真を撮る際に雲海を狙うことが多いのですが、雲海は土日関係なく、もちろん平日でも出ますよね。条件が合えば、平日でも仕事の前にでも行きますね」<br>
                            <br>
                            塚崎「仕事に支障が出たりしませんか？」<br>
                            <br>
                            池田「仕事に支障が出ないよう、無理しないように心がけているので、遅刻などは絶対にしません。でもチャンスがあれば撮影に出かけるスタイルでやっています。写真は趣味としてやっているので、仕事のストレスが発散できますね。写真をSNSで発表しているので、いいねやコメントをもらえるのも嬉しいので、そういうところも写真のいいところだなと思います」<br>
                            <br>
                            塚崎「酒井さんは仕事を春から始められているんですよね。仕事と写真のバランスはどうでしょうか」<br>
                            <br>
                            酒井「一年目ということもあって平日はずっと働いているので、土曜の夜や日曜朝に写真撮影に行きます。写真を撮ることはストレス発散にもなり、リフレッシュできるのでまだ続けていますね」<br>
                            <br>
                            塚崎「石田さんはいかがでしょうか？」<br>
                            <br>
                            石田「僕の場合は趣味と仕事の境目は考えていなくて、仕事も患者さんに笑顔や癒しを与えることが目的だと思っていますし、写真についても自分の写真を見て誰かが笑顔になってほしいなと思っているので、自分の目的のなかでただ手段が違うだけだと思っていますね。どちらも同じ情熱を持ってやっています。気をつけているのは、優先順位だけは常に考えながらやっていますね」<br>
                            <br>
                            塚崎「半田さんはいかがでしょうか？」<br>
                            <br>
                            半田「看護師としても写真家としても、誰かを癒したりポジティブな気持ちになってもらえると嬉しいと思うので、写真と仕事はリンクしているなと思いますね」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/39.jpg" alt="ニコンイメージングジャパン 39" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            半田「病院は無機質なことが多くて、検査の案内とか、張り物もそうだと思うんですね。病院にくるときってやっぱり緊張するじゃないですか。そんな緊張のなかで心がほっとするちょっとした時間を作ろうと、病院がわたしの写真を飾ってくれていて、患者さんからもご好評をいただいているんです。病院が移転してリフォームすることになったのですが、工事の際にわざわざスポットライトまでつけてくれたんです。すごいですよね。ここの病院に骨を埋める覚悟で働きたいと思いました。やっぱり病院側から認めてもらうには、仕事も趣味も本気でやらないと伝わらないと思います。仕事も一生懸命やりたいとわたしは思っています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/40.jpg" alt="ニコンイメージングジャパン 40" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「それではお二人からU-22に向けてメッセージをいただきたいと思います」<br>
                            <br>
                            石田「自分の人生の目的を見つけてしっかり提示した上で、優先順位を考えながら何事も真摯に行動していけばどちらも上手く行くと思っています。強く思うのは、自分がいまこうしてここに立っているのはいろいろな人との繋がり、お世話になった人のおかげでここに来ているので、人との繋がりを大切にして写真を撮っていただけたらなと思います」<br>
                            <br>
                            半田「正直わたしがこうしてカメラのお仕事をしたり、人前で喋るとはまったく思っていませんでした。たまたま東京カメラ部10選の井上さんと出会い、東京カメラ部を紹介してもらったことをきっかけに、東京カメラ部に投稿するようになり、東京カメラ部10選に選ばれ、企業やお仕事などのご縁が繋がりました。いまはInstagramのDMなどでもお仕事をいただける時代で、どこにチャンスがあるかわからないし、誰にでもチャンスは転がっていると思うんですね。自分が撮りたいものを一生懸命撮って、ご縁を大切にすることはとても大切だと思います。井上さんに『自分の目の前に速い川が流れている。乗るのも乗らないのも自分だよ』とアドバイスをもらって、やってみようと思ったんです。やっぱりチャレンジするのも大事だと思います。やってみようかな、というちょっとした自分の気持ちで、皆さんから応援してもらってここまで来れています。応援してもらうのが写真家だと思っているので、自分の頑張りを知ってもらうのも大切だと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/41.jpg" alt="ニコンイメージングジャパン 41" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「それではU-22のお二人からも若い世代へ向けてメッセージをいただきたいと思います」<br>
                            <br>
                            池田「東京カメラ部10選U-22に選出いただいて、こういったトークショーや配信などで発信させていただく機会が増えました。U-22はInstagramのハッシュタグをつけるだけで誰でも簡単に参加できるので、そういった道が本当に誰にでもあるんだなと実感しました。今回選出されたことでいろいろな人からも話しかけてもらえるし、選ばれてよかったと思っています。なんのカメラを使っているということも関係なく、誰にでもチャンスがあると思います」<br>
                            <br>
                            酒井「東京カメラ部10選U-22の特典として、THE GALLERYでの展示とニコンの機材のモニター体験があります。僕の写真経験においても、モニター体験で機種を変えるという大きな転機になりました。それまで写真展をしたことがなかったのですが、自分の思い入れのある写真を展示してもらえる満足感もすごいと思いました。普段Instagramなどでは自分に好意的な方の意見が多いのですが、写真展では自分にフラットな立ち位置で接してくれる方がいたり、意見をいただいたりして、自分の作品を客観的に見れるようになりました。本当にチャレンジしてよかったと思っています。この秋3回目のフォトコンテストが開催されていますので、みなさんにもそこからぜひ挑戦してみてほしいです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/42.jpg" alt="ニコンイメージングジャパン 42" />
                    </div><!-- /inner4-->
                    <div class="exif">
                        <p>
                        </p>
                    </div><!-- /exif-->
                </section><!-- /photoBlock-->
                
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「再度、東京カメラ部10選U-22フォトコンテストについてご説明します。こちらは、22歳以下、もしくは20代の学生に参加を限定したフォトコンテストです。今年も開催をしております。東京カメラ部10選U-22に認定された方は、ニコン機のモニター無料貸出と、ニコンが運営するTHE GALLERYでの展示をしていただけます。東京と大阪両方で展示されます。ここのギャラリーはプロの写真家が目指す場所なんです。とても大きなプリントで展示されていますよね。ぜひこちらのフォトコンに挑戦していただきたいと思っています。以上をもちましてトークショーを終了させていただきます。みなさまありがとうございました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="relatedInfo">
                    <div class="inner2">
                        <h3>関連リンク</h3>
                        <div class="relatedfTxt">
                            <span></span>
                            <p class="relatedLink">
                                <a href="https://www.nikon-image.com/products/mirrorless/lineup/z_9/" target="_blank" rel="noopener noreferrer">「Z 9」製品情報ページ</a>
                            </p>
                            <p class="relatedLink">
                                <a href="https://www.nikon-image.com/products/mirrorless/lineup/z_7_2/" target="_blank" rel="noopener noreferrer">「Z 7II」製品情報ページ</a>
                            </p>
                            <p class="relatedLink">
                                <a href="https://www.nikon-image.com/activity/exhibition/thegallery/" target="_blank" rel="noopener noreferrer">ニコンが企画し発信する写真展会場「THE GALLERY」</a>
                            </p>
                        </div>
                    </div>
                </section>

                <section class="bnrBlock1">
                    <div class="inner4">
                        <a target="_blank" href="https://nikkor.tokyocameraclub.com/u22contest2022/"><picture><source media="(max-width:640px)" srcset="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/U22_960x200.jpg"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/U22_960x200.jpg" alt="東京カメラ部10選U-22フォトコンテスト"></picture></a>
                    </div><!-- /inner4-->
                </section><!-- /bnrBlock1-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="profile">
                  <div class="inner2 clearfix">
                    <div class="left"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/prof_01.jpg" alt="石田卓士"></div>
                    <div class="right">
                        <h3 class="profName" style="word-break: break-all;;">石田卓士</h3><!-- <h4 class="profNameSub">石田卓士</h4> -->
                        <p class="profTxt">
                          <span style="white-space: pre-wrap;">
                            1971年生まれ。新潟県上越市在住。地元の棚田の美しさに惹かれ、総合病院で呼吸器内科医として働く傍ら、2016年から風景写真を撮り始める。その土地に対する想いと独自性を大切にしている。
                          </span>
                        </p>
                    </div>
                  </div><!-- /inner-->
                </section><!-- /profile-->

                <section class="profile">
                  <div class="inner2 clearfix">
                    <div class="left"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/prof_02.jpg" alt="半田菜摘"></div>
                    <div class="right">
                        <h3 class="profName" style="word-break: break-all;;">半田菜摘</h3><!-- <h4 class="profNameSub">半田菜摘</h4> -->
                        <p class="profTxt">
                          <span style="white-space: pre-wrap;">
                            1986年北海道旭川市生まれ。友人の素晴らしい写真を見たのをキッカケにカメラを購入。2013年より写真を始める。看護師として病棟勤務する傍ら、夜勤明けや休日に、公園や森、山に入り北海道に暮らす野生動物を撮影。作品をSNSや写真展で発表するほか、フジテレビ系列のドキュメンタリー番組【セブンルール】に出演。また、雑誌、企業広告、カレンダーなど幅広く作品を提供。2021年写真集【Pirka】出版。動物たちの美しい毛並みや瞳、ありのままの仕草や表情、生命の営みが伝わる作品を目指して撮影に取り組んでいる。
                          </span>
                        </p>
                    </div>
                  </div><!-- /inner-->
                </section><!-- /profile-->

                <section class="profile">
                  <div class="inner2 clearfix">
                    <div class="left"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/prof_03.jpg" alt="池田拓海"></div>
                    <div class="right">
                        <h3 class="profName" style="word-break: break-all;;">池田拓海</h3><!-- <h4 class="profNameSub">池田拓海</h4> -->
                        <p class="profTxt">
                            <span style="white-space: pre-wrap;">
                              2021年、東京カメラ部10選U22に選出される。<br>
                              熊本県在住、主に阿蘇くじゅうの風景写真を撮影。<br>
                              高校3年生の頃に友人のカメラに触れ、撮影することの楽しさを知ったことをきっかけにNikonD5300を購入。最初の頃は熊本空港で飛行機を撮影。自宅や職場から阿蘇が身近な距離にあり風景写真を撮り始めた。現在はNikonZ6を使用し、風景の他にモトクロスや花火の撮影もしている。まだ見たことのない絶景を求め、九州各地を走り回っている。
                            </span>
                        </p>
                    </div>
                  </div><!-- /inner-->
                </section><!-- /profile-->

                <section class="profile">
                  <div class="inner2 clearfix">
                    <div class="left"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/prof_04.jpg" alt="酒井雄世"></div>
                    <div class="right">
                        <h3 class="profName" style="word-break: break-all;;">酒井雄世</h3><!-- <h4 class="profNameSub">酒井雄世</h4> -->
                        <p class="profTxt">
                            <span style="white-space: pre-wrap;">
                              もともと旅行が好きだったこともあり、大学2年生の時に一眼レフを購入。以降、医学を志す傍ら、非日常な風景を求めて日本各地を撮り歩き、東京カメラ部U-22 初代10選に選出。当コンテストでのNikon ZシリーズモニターをきっかけにNikonのミラーレス一眼の画力に感銘を受け、2021年の12月にNikon Z7Ⅱを購入。2022年春から医師として働く反面、写真活動を続け、今に至る。
                            </span>
                        </p>
                    </div>
                  </div><!-- /inner-->
                </section><!-- /profile-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <div class="actionMenu">
        <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.report .reportVhead01{
    background-image: url("https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/nikon_u22/titleBk.jpg");
    background-repeat: no-repeat;
    background-position: top center;
}
.natgeoLinkArea {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
}
.natgeoLinkArea div {
    width: 43%;
    margin-bottom: 24px;
}

#main .relatedInfo {
    border-top: unset;
    padding: 0px 0px 80px 0px;
}
#main .relatedInfo h3 {
    font-size: 1rem;
    line-height: 3.0em;
    text-align: justify;
    margin: 0;
    font-weight: 600;
    font-style: normal;
    word-break: break-all;
}
#main .relatedInfo .inner2 {
    margin: 0 auto;
    position: relative;
    width: 960px;
    min-width: 960px;
}
#main .relatedInfo .relatedLink {
    font-size: 1rem;
    line-height: 2.0em;
    text-align: justify;
    margin: 0;
    font-family: a-otf-midashi-go-mb31-pr6n,sans-serif;
    font-weight: 600;
    font-style: normal;
    word-break: break-all;
}
@media screen and (max-width:1024px){
    #main .relatedInfo .inner2 {
        width: unset;
        min-width: unset;
    }
}

@media screen and (max-width:640px){
    #main .relatedInfo .inner2 {
        width: unset;
        min-width: unset;
    }
    .natgeoLinkArea {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .natgeoLinkArea div {
        width: unset;
        margin: 24px 16px;
    }
}
</style>
